import { useState, type ReactNode } from 'react'
import type { CustomFieldValue } from 'types/entity'

export interface DetailField {
  label: string
  value: ReactNode
  /** Renders across the full grid width with a hover tooltip (addresses, remarks). */
  wide?: boolean
  badge?: boolean
}

/**
 * Right column of the view screen — the "Other Details" panel plus the
 * More../Less.. custom-field drawer (`#other-detailsbox`).
 */
export function OtherDetails({
  fields,
  customFields,
  customFieldsLoading,
}: {
  fields: DetailField[]
  customFields: CustomFieldValue[]
  customFieldsLoading?: boolean
}) {
  const [showMore, setShowMore] = useState(false)

  return (
    <div className="entity-right">
      <h5>Other Details</h5>

      <div className="detail-grid">
        {fields.map((field) => (
          <div key={field.label} className={`detail-item${field.wide ? ' full' : ''}`}>
            <span className="k">{field.label}:</span>
            {field.wide ? (
              <span className="tooltip-card">
                <span className="address-cont">{field.value || '—'}</span>
                {field.value ? <span className="tooltiptext">{field.value}</span> : null}
              </span>
            ) : field.badge ? (
              <span className="badge badge-success">{field.value || '—'}</span>
            ) : (
              <span>{field.value || '—'}</span>
            )}
          </div>
        ))}
      </div>

      {showMore && (
        <>
          <hr />
          {customFieldsLoading ? (
            <div className="inline-loader">Loading custom fields…</div>
          ) : customFields.length === 0 ? (
            <div className="empty-state">No custom fields configured.</div>
          ) : (
            <div className="detail-grid">
              {customFields.map((field, i) => (
                <div key={`${field.label}-${i}`} className="detail-item">
                  <span className="k">{field.label}:</span>
                  <span>{field.value || '—'}</span>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      <div className="mt-1">
        <button type="button" className="link-btn" onClick={() => setShowMore((v) => !v)}>{showMore ? 'Less..' : 'More..'}</button>
      </div>
    </div>
  )
}
